import React from 'react';
import './DropLetter.scss';

interface DropLetterProps {
  letter: string;
}

function DropLetter({ letter }: DropLetterProps) {
  return <span className="drop-letter">{letter}</span>;
}

export default DropLetter;
